<template>
<div>
  <h3>基础问询</h3><br/>
    <el-form
    ref="form"
    size="mini"
    label-position="left"
    label-width="150px"
    class="demo-form-inline"
    :model="examBasicQuery"
    :disabled="disabled"
  >
    <el-form-item label="饮食1小时及以上：" label-width="150px">
      <span>{{ examBasicQuery.dietAfterHour ? "是": "否"}}</span>
      <!-- <el-switch v-model="examBasicQuery.dietAfterHour"></el-switch> -->
    </el-form-item>
    <el-form-item label="作息：">
      晚上{{examBasicQuery.sleepRange.sleep ? examBasicQuery.sleepRange.sleep: "?"}}
      点睡觉，
      {{examBasicQuery.sleepRange.getup ?examBasicQuery.sleepRange.getup:"?"}}
      点起床， 合计
      {{examBasicQuery.sleepRange.total ?examBasicQuery.sleepRange.total:"?"}}
      小时
    </el-form-item>
    <!-- <el-form-item label="有无：">
      <span v-for="(item,index) in examBasicQuery.sleepProblem" :key="index">{{item}},</span>
      <el-checkbox-group v-model="examBasicQuery.sleepProblem" :min="0">
        <el-checkbox label="良好"></el-checkbox>
        <el-checkbox label="一般"></el-checkbox>
        <el-checkbox label="入睡难"></el-checkbox>
        <el-checkbox label="易醒"></el-checkbox>
        <el-checkbox label="多梦"></el-checkbox>
        <el-checkbox label="起夜"></el-checkbox>
      </el-checkbox-group>
    </el-form-item> -->
    <el-form-item label="饮酒：">
      <span>{{examBasicQuery.drinking.choice}}，</span>
      <span style="margin-left: 20px"
        >{{examBasicQuery.drinking.year ?examBasicQuery.drinking.year:"?"}}年， 
        每周{{examBasicQuery.drinking.frequency?examBasicQuery.drinking.frequency:"?"}}次</span
      >
      <!-- <el-radio-group v-model="examBasicQuery.drinking.choice" @change="drinkingFreqChange">
        <el-radio label="从不"></el-radio>
        <el-radio label="偶尔"></el-radio>
        <el-radio label="经常"></el-radio>
      </el-radio-group>
      <span style="margin-left: 20px"
        ><el-input
          class="small-input"
          v-model="examBasicQuery.drinking.year"
        />年， 每周<el-input
          v-model="examBasicQuery.drinking.frequency"
          class="small-input"
        />次</span
      > -->
    </el-form-item>
    <el-form-item label="饮酒类型：">
      <span v-show="examBasicQuery.drinking.types.length>0" v-for="(item,index) in examBasicQuery.drinking.types" :key="index">{{item}},</span>
      <!-- <el-checkbox-group
        v-model="examBasicQuery.drinking.types"
        :disabled="examBasicQuery.drinking.choice=='从不'"
      >
        <el-checkbox label="啤酒"></el-checkbox>
        <el-checkbox label="红酒"></el-checkbox>
        <el-checkbox label="白酒"></el-checkbox>
      </el-checkbox-group> -->
    </el-form-item>
    <el-form-item label="抽烟史：">
      <span>{{examBasicQuery.smoking.choice}}，</span>
      
      <span style="margin-left: 20px" v-show="examBasicQuery.smoking.choice !=='从不'"
        >吸烟{{examBasicQuery.smoking.year?examBasicQuery.smoking.year:"?"}}年，
        {{examBasicQuery.smoking.frequency?examBasicQuery.smoking.frequency:"?"}}支/日</span
      >
      <!-- <span>
        <el-radio-group v-model="examBasicQuery.smoking.choice">
          <el-radio label="从不"></el-radio>
          <el-radio label="偶尔"></el-radio>
          <el-radio label="经常"></el-radio>
          <el-radio label="戒烟"></el-radio>
        </el-radio-group>
      </span>
      <span style="margin-left: 20px"
        >吸烟<el-input
          class="small-input"
          v-model="examBasicQuery.smoking.year"
        />年，
        <el-input
          v-model="examBasicQuery.smoking.frequency"
          class="small-input"
        />支/日</span
      > -->
    </el-form-item>
    <el-form-item label="运动：">
      {{ examBasicQuery.sport.hasSport ? "有" :"无" }}
    </el-form-item>
    <el-form-item label="运动方式：" >
      <span v-show="examBasicQuery.sport.hasSport" v-for="(item,index) in examBasicQuery.sport.types" :key="index">{{item}},</span>
      <!-- <el-checkbox-group
        v-model="examBasicQuery.sport.types"
        :disabled="!examBasicQuery.sport.hasSport"
      >
        <el-checkbox label="快走"></el-checkbox>
        <el-checkbox label="跑步"></el-checkbox>
        <el-checkbox label="足球"></el-checkbox>
        <el-checkbox label="爬山"></el-checkbox>
        <el-checkbox label="跳绳"></el-checkbox>
        <el-checkbox label="游泳"></el-checkbox>
        <el-checkbox label="羽毛球"></el-checkbox>
        <el-checkbox label="太极"></el-checkbox>
        <el-checkbox label="站桩"></el-checkbox>
        <el-checkbox label="马拉松"></el-checkbox>
        <el-checkbox label="其他"></el-checkbox>
      </el-checkbox-group> -->
    </el-form-item>
    <el-form-item label="近期精神：" v-show="examBasicQuery.currentSpirit.length>0">
      <span  v-for="(item,index) in examBasicQuery.currentSpirit" :key="index">{{item}},</span>
      <!-- <el-checkbox-group v-model="examBasicQuery.currentSpirit">
        <el-checkbox label="安逸舒适"></el-checkbox>
        <el-checkbox label="平常"></el-checkbox>
        <el-checkbox label="反应淡漠"></el-checkbox>
        <el-checkbox label="健忘/注意力不集中"></el-checkbox>
        <el-checkbox label="退缩回避"></el-checkbox>
        <el-checkbox label="焦虑紧张"></el-checkbox>
        <el-checkbox label="烦躁易怒"></el-checkbox>
        <el-checkbox label="抑郁"></el-checkbox>
      </el-checkbox-group> -->
    </el-form-item>
    <el-form-item label="性格：">
      <span>{{examBasicQuery.personalityType}}</span>
      <!-- <el-radio-group v-model="examBasicQuery.personalityType">
        <el-radio label="A型性格"></el-radio>
        <el-radio label="B型性格"></el-radio>
        <el-radio label="C型性格"></el-radio>
      </el-radio-group> -->
    </el-form-item>
    <el-form-item >
      <span v-if="examBasicQuery.personalityType =='A型性格'">
        A型性格：{{Personalities.A}}
      </span>
      <span v-else-if="examBasicQuery.personalityType =='B型性格'"
        title="B型性格"
        :description="Personalities.B"
        show-icon>B型性格：{{Personalities.B}}
      </span>
      <span v-else-if="examBasicQuery.personalityType =='C型性格'"
        title="C型性格"
        :description="Personalities.C"
        show-icon>C型性格：{{Personalities.C}}
      </span>
      <span v-else
        title="请选择性格类型"
        show-icon>您没有选择性格类型。
      </span>
    </el-form-item>
    <el-form-item label="目前您认为最困扰的不适有哪些：" label-width="240px">
      <span>{{examBasicQuery.mostBother}}</span>
      <!-- <el-input
        type="textarea"
        v-model="examBasicQuery.mostBother"
        :autosize="{ minRows: 4, maxRows: 6 }"
      ></el-input> -->
    </el-form-item>
  
  </el-form>
</div>

</template>

<script>
import { 
  ExamStatesValue, 
  Personalities 
  } from "../../utils/constants";
import { Util_updateExamState } from "../../utils/util";
import {
  getExamBasicQuery,
  updateExamBasicQuery,
  updateExamState,
} from "../../api/userExamService";

export default {
  name: "BasicQuery",
  props: {
    examUuid: String,
    disabled: Boolean,
  },
  data() {
    return {
      submitting: false,
      Personalities,
      //基础问询-前端格式
      examBasicQuery: {
        examUuid: "",
        dietAfterHour: true,
        sleepRange: {
          sleep: "",
          getup: "",
          total: "",
        },
        sleepProblem: [],
        drinking: {
          choice: "从不",
          year: "",
          frequency: "",
          types:[],
        },
        smoking: {
          choice: "从不",
          year: "",
          frequency: "",
        },
        sport: {
          hasSport: false,
          types: [],
        },
        // medicine: {
        //   hasMedicine: false,
        //   name: "",
        // },
        // healthProduct: {
        //   hasHealthProduct: false,
        //   name: "",
        // },
        currentSpirit: [],
        personalityType: "",
        mostBother: "",
      },
      //基础问询-后端格式
      model: {
        examUuid: "",
        dietAfterHour: true,
        sleepRange: "",
        sleepProblem: "",
        drinking: "",
        smoking: "",
        sport: "",
        // medicine: "",
        // healthProduct: "",
        currentSpirit: "",
        personalityType: "",
        mostBother: "",
      },
    };
  },
  methods: {
    drinkingFreqChange( value ){
      if(value == "从不"){
        this.examBasicQuery.drinking.types =[];
      }
    },
    //获取基础问询
    _getExamBasicQuery() {
      getExamBasicQuery(this.examUuid).then((res) => {
        if (res.success) {
          if (res.data[0]) {
            this.model = res.data[0];
            //将数据转化为合适的格式后，赋值给examBasicQuery (这是前端展示的格式)
            this.examBasicQuery = this.getConvertor(res.data[0]);
          }
        } else {
          this.$message({ message: res.description, type: "error" });
        }
        // console.log("examBasicQuery", this.examBasicQuery);
      });
    },
    //更新基础问询
    _updateExamBasicQuery() {
      //转换格式发送给后端;
      // console.log(this.examBasicQuery)

      this.model = this.postDataConvertor(this.examBasicQuery);
      // console.log(this.model)
      //// this.model是发送给后端的数据格式
      // data varifu
      // console.log("model",this.model);
      // console.log("2 convert" , this.postDataConvertor (this.getConvertor(this.model)))
      // console.log("identical",  this.ObectIdenticalTest(this.model, this.postDataConvertor (this.getConvertor(this.model))))
      // console.log("converted model", this.getConvertor(this.model));

      // let ii=true;
      // if(ii){
      //   return
      // }
      this.submitting= true;
      updateExamBasicQuery(this.model)
      .then(
        (res) => {
          this.submitting= false;
          if (res.success) {
            this.$message({ message: res.description, type: "success"});
            //更新检查状态后，重新获取检查信息
            this._updateExamState( ExamStatesValue.BASIC_QUERY_30, this._getExamBasicQuery );
          } else {
            this.$message({
              message: res.description,
              type: "warning",
            });
          }
        }
      ).catch (e => {
        this.submitting= false;
        console.log(e)
      });
    },
    //更新检查状态、并重新获取更新的信息
    _updateExamState(state, reloadFunc) {
      //如果已到达，则将其状态改为30:基础问询中
      Util_updateExamState(
        this.examUuid,
        state,
        updateExamState,
        reloadFunc,
        this.$message
      );
    },
    // data with typeof prop's value is string with splitter convert to Array
    getConvertor(data, direction, splitter = "^") {
      let convertedData = {
        examUuid: "",
        dietAfterHour: true,
        sleepRange: "",
        sleepProblem: "",
        drinking: "",
        smoking: "",
        sport: "",
        // medicine: "",
        // healthProduct: "",
        currentSpirit: "",
        personalityType: "",
        mostBother: "",
      };
      if (typeof data == "object") {
        for (let key in data) {
          let temp;
          switch (key) {
            case "examUuid":
              convertedData[key] = data[key];
              break;
            case "dietAfterHour":
              convertedData[key] = JSON.parse(data[key]);
              break;
            case "sleepRange":
              temp = data[key].split(splitter);
              convertedData[key] = {
                sleep: temp[0],
                getup: temp[1],
                total: temp[2],
              };
              break;
            case "sleepProblem":
              convertedData[key] = data[key].split(splitter);
              break;
            case "drinking":
              temp = data[key].split(splitter);
              convertedData[key] = {
                choice: temp[0],
                year: temp[1],
                frequency: temp[2],
              };
              
              if(temp.length >3 ){
                convertedData[key].types = temp[3].split(',').filter(function(el) {
                  return el != "";
                });
              }
              //考虑以前的数据 没有 饮酒类型时，将type设置为[]'
              else{
                convertedData[key].types = [];
              }
              console.log('drinking-types',convertedData[key].types)
              break;
            case "smoking":
              temp = data[key].split(splitter);
              convertedData[key] = {
                choice: temp[0],
                year: temp[1],
                frequency: temp[2],
              };
              break;
            case "sport":
              temp = data[key].split(splitter);
              if (temp.length >= 1 && temp[0] != "") {
                convertedData[key] = {
                  hasSport: true,
                  types: temp,
                };
              } else {
                convertedData[key] = {
                  hasSport: false,
                  types: [],
                };
              }
              break;
            // case "medicine":
            //   temp = data[key];
            //   if (temp != "") {
            //     convertedData[key] = {
            //       hasMedicine: true,
            //       name: temp,
            //     };
            //     // convertedData[key].hasMedicine = true;
            //   } else {
            //     convertedData[key] = {
            //       hasMedicine: false,
            //       name: temp,
            //     };
            //     // convertedData[key].hasMedicine = false;
            //   }
            //   // convertedData[key].name = temp;
            //   break;
            // case "healthProduct":
            //   temp = data[key];
            //   if (temp != "") {
            //     convertedData[key] = {
            //       hasHealthProduct: true,
            //       name: temp,
            //     };
            //     // convertedData[key].hasHealthProduct = true;
            //   } else {
            //     convertedData[key] = {
            //       hasHealthProduct: false,
            //       name: temp,
            //     };
            //     // convertedData[key].hasHealthProduct = false;
            //   }
            //   // convertedData[key].name = temp;
            //   break;
            case "currentSpirit":
              temp = data[key].split(splitter);
              convertedData[key] = temp;
              break;
            case "personalityType":
              convertedData[key] = data[key];
              break;
            case "mostBother":
              convertedData[key] = data[key];
              break;
          }
        }
        return convertedData;
      } else {
        alert("转换器不能转换非对象");
        return false;
      }
    },
    // data with typeof prop's value is Array convert to string with splitter
    postDataConvertor(data, splitter = "^") {
      let convertedData = {
        examUuid: "",
        dietAfterHour: true,
        sleepRange: "",
        sleepProblem: "",
        drinking: "",
        smoking: "",
        sport: "",
        // medicine: "",
        // healthProduct: "",
        currentSpirit: "",
        personalityType: "",
        mostBother: "",
      };
      if (typeof data == "object") {
        for (let key in data) {
          switch (key) {
            case "examUuid":
              convertedData[key] = data[key];
              break;
            case "dietAfterHour":
              convertedData[key] = data[key];
              break;
            case "sleepRange":
              convertedData[key] =
                data[key].sleep +
                splitter +
                data[key].getup +
                splitter +
                data[key].total;
              break;
            case "sleepProblem":
              convertedData[key] = data[key].join(splitter);
              break;
            case "drinking":
              convertedData[key] =
                data[key].choice +
                splitter +
                data[key].year +
                splitter +
                data[key].frequency +
                splitter +
                data[key].types.join(",");
              break;
            case "smoking":
              convertedData[key] =
                data[key].choice +
                splitter +
                data[key].year +
                splitter +
                data[key].frequency;
              break;
            case "sport":
              if (data[key].hasSport) {
                convertedData[key] = data[key].types.join(splitter);
              } else {
                convertedData[key] = "";
              }
              break;
            // case "medicine":
            //   if (data[key].hasMedicine) {
            //     convertedData[key] = data[key].name;
            //   } else {
            //     convertedData[key] = "";
            //   }
            //   break;
            // case "healthProduct":
            //   if (data[key].hasHealthProduct) {
            //     convertedData[key] = data[key].name;
            //   } else {
            //     convertedData[key] = "";
            //   }
            //   break;
            case "currentSpirit":
              convertedData[key] = data[key].join(splitter);
              break;
            case "personalityType":
              convertedData[key] = data[key];
              break;
            case "mostBother":
              convertedData[key] = data[key];
              break;
          }
        }
        return convertedData;
      } else {
        alert("转换器不能转换非对象");
        return false;
      }
    },
    // test two Object is Indentical: (props are basic data types)
    ObectIdenticalTest(obj1, obj2) {
      let flag = true;
      for (let key in obj1) {
        // if(obj1[key] )
        if (obj1[key] != obj2[key]) {
          flag = false;
          return flag;
        }
      }
      for (let key in obj2) {
        if (obj2[key] != obj1[key]) {
          flag = false;
          return flag;
        }
      }
      return flag;
    },

  },
  created() {
    this.examBasicQuery.examUuid = this.examUuid;
    this.model.examUuid = this.examUuid;
    this._getExamBasicQuery();
  },
};
</script>

<style scoped>
.small-input {
  width: 70px;
}
.fullWidth {
  width: 100%;
}

.fr {
  float: right;
}
.fl {
  float: left;
}
</style>
